import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CouponIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="17.897" height="16.108" opacity="0.8" viewBox="0 0 17.897 16.108">
		<g transform="translate(-1.75 1)">
			<g transform="translate(1.75 -1)">
				<path
					d="M17.227,9.375a1.321,1.321,0,1,1,0-2.642.674.674,0,0,0,.474-.194.663.663,0,0,0,.2-.471v-2.4A3.7,3.7,0,0,0,14.189,0H3.708A3.7,3.7,0,0,0,0,3.673V6.146a.663.663,0,0,0,.2.471.674.674,0,0,0,.474.194A1.262,1.262,0,0,1,2,8.055,1.328,1.328,0,0,1,.671,9.375.668.668,0,0,0,0,10.04v2.394a3.7,3.7,0,0,0,3.708,3.674H14.19A3.7,3.7,0,0,0,17.9,12.434V10.04a.668.668,0,0,0-.671-.665"
					fill="#f2f6f6"
				/>
				<path
					d="M6.341,3.032,5.286,4.059l.25,1.452a.663.663,0,0,1-.963.7l-1.3-.685-1.3.685a.661.661,0,0,1-.959-.7l.249-1.452L.2,3.032A.662.662,0,0,1,.57,1.9L2.025,1.69,2.678.369A.661.661,0,0,1,3.271,0h0a.659.659,0,0,1,.592.37L4.517,1.69,5.975,1.9a.661.661,0,0,1,.366,1.128"
					transform="translate(5.678 4.654)"
					fill="#114f51"
				/>
			</g>
		</g>
	</svg>
);
